import { BaseVariant } from '../index'

export function useNftListV2Flag(): BaseVariant {
  return BaseVariant.Enabled
}

export { BaseVariant as NftListV2Variant }
